import React, {useEffect, useState} from 'react';
import * as Handlebars from 'handlebars';
import {axios} from '@/lib/axios';
import 'react-tooltip/dist/react-tooltip.css'
import {useLoadingStore} from '@/stores/loading';
import {useMessageModalStore} from '@/stores/message'
import * as Config from '@/config'
import DOMPurify from "dompurify";

export const ServiceStartInformationMailViewer = () => {

  const setLoading = useLoadingStore(state => state.setLoading);
  const setMessage = useMessageModalStore(state => state.setMessage);
  const [previewHtml, setPreviewHtml] = useState('');
  const [subject, setSubject] = useState('');
  
  function getServiceStartInformation() {
    setLoading(true);
    axios.get('/api/v1/datas/getServiceStartInformation')
    .then(res => {
      //console.log(res.data)
      //console.log(res.data.templateData);
      //console.log(typeof res.data.templateData);
      const subject = res.data.SubjectPart;
      const compiled = Handlebars.compile(res.data.HtmlPart);
      const result = compiled(res.data.templateData);
      setPreviewHtml(result);
      setSubject(subject);
    }).catch(error => {      
      setMessage(Config.MESSAGE_NO_E39);
    }).finally(() => {
      setLoading(false);
    });
  }
  useEffect(() => {
        getServiceStartInformation();
  }, []);

  return (
    <>
      <div className="mail-viewer">
        <div className='mail-viewer-subject'>{subject}</div>
        <hr />
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(previewHtml) }} />
      </div>
    </>
  )
}
